/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Manage_Team_ButtonInputs */



/**
* | output |
* | --- |
* | "Manage Team" |
*
* @param {Team_Share_Manage_Team_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_manage_team_button = /** @type {((inputs?: Team_Share_Manage_Team_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Manage_Team_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer l’équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Team leiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestire il team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление командой")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestionar equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理团队")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チーム管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम का प्रबंधन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciar equipe")
	return /** @type {LocalizedString} */ ("Manage Team")
});